export const markets = ['dk', 'fi', 'lt', 'no', 'se', 'uk'];
